export default class TpClientInvoiceLineitemUpsertItem {
  constructor(clientInvoiceId, currencyId, clientId, item, isInvoiceFinalized = false) {
    this.TpClientInvoiceId = clientInvoiceId;
    this.CurrencyId = currencyId;
    this.CaspianClientId = clientId;
    // Drives which fields the editor locks: on a finalized invoice only the internal line item
    // type stays editable.
    this.IsInvoiceFinalized = isInvoiceFinalized;

    if (item) {
      this.TpClientInvoiceLineItemId = item.LineItemId;
      this.TypeLookupItemValue = item.LineItemTypeId;
      this.InternalLineItemTypeLookupValue = item.InternalLineItemTypeId ?? item.LineItemTypeId;
      this.ProjectId = item.ProjectId;
      this.ServiceId = item.ServiceId;
      this.Description = item.Name;
      this.Total = item.InitialTotalDue;
      this.TiedToType = item.ProjectId ? 'Project' : item.ServiceId ? 'Service' : null;
      return;
    }
    this.TypeLookupItemValue = null;
    this.InternalLineItemTypeLookupValue = null;
    this.ProjectId = null;
    this.ServiceId = null;
    this.Description = '';
    this.Total = 0;
    this.TiedToType = null;
  }
}
